'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _NewFolderView = require('../components/Browser/Folders/NewFolderView.jsx');

var _NewFolderView2 = _interopRequireDefault(_NewFolderView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return state.newFolder;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onClose: function onClose() {
      dispatch((0, _actions.cancelNewFolder)());
    },
    onChange: function onChange(e) {
      var name = e.currentTarget.value;
      if (!name) return;
      dispatch((0, _actions.createNewFolder)(name, function (folder) {
        dispatch((0, _actions.addFolder)(folder));
      }));
    }
  };
};

var NewFolder = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_NewFolderView2.default);

exports.default = NewFolder;


//////////////////
// WEBPACK FOOTER
// ./client/containers/newFolder.js
// module id = 74
// module chunks = 0